/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getActiveMissionRouteV2 = /* GraphQL */ `query GetActiveMissionRouteV2($vin: String!) {
  getActiveMissionRouteV2(vin: $vin) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on GeneratedRouteV2 {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      positions {
        altitude
        heading
        latitude
        longitude
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
    }
  }
}
` as GeneratedQuery<
  APITypes.GetActiveMissionRouteV2QueryVariables,
  APITypes.GetActiveMissionRouteV2Query
>;
export const getActiveMissionV2 = /* GraphQL */ `query GetActiveMissionV2($vin: String!) {
  getActiveMissionV2(vin: $vin) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedQuery<
  APITypes.GetActiveMissionV2QueryVariables,
  APITypes.GetActiveMissionV2Query
>;
export const getCameraImageByVIN = /* GraphQL */ `query GetCameraImageByVIN($cameraID: ID, $vin: String!) {
  getCameraImageByVIN(cameraID: $cameraID, vin: $vin) {
    timestamp
    value
  }
}
` as GeneratedQuery<
  APITypes.GetCameraImageByVINQueryVariables,
  APITypes.GetCameraImageByVINQuery
>;
export const getFleetById = /* GraphQL */ `query GetFleetById($id: ID!) {
  getFleetById(id: $id) {
    fleetId
    vehicles {
      name
      vin
    }
  }
}
` as GeneratedQuery<
  APITypes.GetFleetByIdQueryVariables,
  APITypes.GetFleetByIdQuery
>;
export const getHealthStatus = /* GraphQL */ `query GetHealthStatus {
  getHealthStatus {
    status
  }
}
` as GeneratedQuery<
  APITypes.GetHealthStatusQueryVariables,
  APITypes.GetHealthStatusQuery
>;
export const getHub = /* GraphQL */ `query GetHub($id: ID!) {
  getHub(id: $id) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.GetHubQueryVariables, APITypes.GetHubQuery>;
export const getMission = /* GraphQL */ `query GetMission($id: ID!) {
  getMission(id: $id) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedQuery<
  APITypes.GetMissionQueryVariables,
  APITypes.GetMissionQuery
>;
export const getMissionV2 = /* GraphQL */ `query GetMissionV2($id: ID!) {
  getMissionV2(id: $id) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedQuery<
  APITypes.GetMissionV2QueryVariables,
  APITypes.GetMissionV2Query
>;
export const getSystemTeamInfo = /* GraphQL */ `query GetSystemTeamInfo($id: ID!) {
  getSystemTeamInfo(id: $id) {
    createdAt
    fleets {
      id
      name
    }
    id
    updatedAt
    users {
      firstName
      id
      lastName
    }
  }
}
` as GeneratedQuery<
  APITypes.GetSystemTeamInfoQueryVariables,
  APITypes.GetSystemTeamInfoQuery
>;
export const getSystemVersion = /* GraphQL */ `query GetSystemVersion {
  getSystemVersion {
    services {
      service
      version
    }
    version
  }
}
` as GeneratedQuery<
  APITypes.GetSystemVersionQueryVariables,
  APITypes.GetSystemVersionQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    city
    country
    createdAt
    email
    firstName
    id
    lastName
    phone
    roles {
      claims {
        createdAt
        pattern
        updatedAt
      }
      createdAt
      id
      name
      updatedAt
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getVehicleByVIN = /* GraphQL */ `query GetVehicleByVIN($vin: String!) {
  getVehicleByVIN(vin: $vin) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleByVINQueryVariables,
  APITypes.GetVehicleByVINQuery
>;
export const getVehicleByVINV2 = /* GraphQL */ `query GetVehicleByVINV2($vin: String!) {
  getVehicleByVINV2(vin: $vin) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on VehicleV2 {
      activeMissionId {
        error {
          raisedAt
          type
        }
        ttl
        value {
          data
          updatedAt
        }
      }
      adsState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      connectivityStatus {
        error {
          raisedAt
          type
        }
        ttl
        value {
          expectDisconnection
          latency
          state
          updatedAt
        }
      }
      deviations {
        error {
          raisedAt
          type
        }
        ttl
        value {
          deviation {
            category
            description
            id
            isBlocking
            origin
            relatedDeviations
            resolvedAt
            sentAt
            severity
            state
          }
          updatedAt
        }
      }
      driverMode {
        error {
          raisedAt
          type
        }
        ttl
        value {
          mode
          updatedAt
        }
      }
      drivingState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      fleetId
      latestVehicleUpdate
      licensePlate
      mrmState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          data {
            causes
            executionPhase
            mrmType
            startedAt
            triggerBy
            value
          }
          updatedAt
        }
      }
      name
      owners {
        email
        fullName
        id
        phoneNumber
        position
      }
      position {
        error {
          raisedAt
          type
        }
        ttl
        value {
          position {
            altitude
            heading
            latitude
            longitude
          }
          updatedAt
        }
      }
      speedMs {
        error {
          raisedAt
          type
        }
        ttl
        value {
          speedMs
          updatedAt
        }
      }
      timestamp
      vin
    }
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleByVINV2QueryVariables,
  APITypes.GetVehicleByVINV2Query
>;
export const getVideoStreamingURL = /* GraphQL */ `query GetVideoStreamingURL($cameraID: String, $vin: String!) {
  getVideoStreamingURL(cameraID: $cameraID, vin: $vin) {
    cameraID
    streamingURL
    vin
  }
}
` as GeneratedQuery<
  APITypes.GetVideoStreamingURLQueryVariables,
  APITypes.GetVideoStreamingURLQuery
>;
export const listFleets = /* GraphQL */ `query ListFleets {
  listFleets {
    createdAt
    id
    name
    numberOfVehicles
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.ListFleetsQueryVariables,
  APITypes.ListFleetsQuery
>;
export const listHubs = /* GraphQL */ `query ListHubs {
  listHubs {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListHubsQueryVariables, APITypes.ListHubsQuery>;
export const listRoles = /* GraphQL */ `query ListRoles {
  listRoles {
    claims {
      createdAt
      pattern
      updatedAt
    }
    createdAt
    id
    name
    updatedAt
    useWildcardClaims
  }
}
` as GeneratedQuery<APITypes.ListRolesQueryVariables, APITypes.ListRolesQuery>;
export const listRoutes = /* GraphQL */ `query ListRoutes {
  listRoutes {
    averageDuration
    createdAt
    distance
    id
    landingHub {
      active
      address
      createdAt
      id
      name
      position {
        latitude
        longitude
      }
      updatedAt
    }
    launchHub {
      active
      address
      createdAt
      id
      name
      position {
        latitude
        longitude
      }
      updatedAt
    }
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.ListRoutesQueryVariables,
  APITypes.ListRoutesQuery
>;
export const listSystemTeams = /* GraphQL */ `query ListSystemTeams {
  listSystemTeams {
    createdAt
    id
    name
    numberOfFleets
    numberOfUsers
    updatedAt
  }
}
` as GeneratedQuery<
  APITypes.ListSystemTeamsQueryVariables,
  APITypes.ListSystemTeamsQuery
>;
export const listUsers = /* GraphQL */ `query ListUsers {
  listUsers {
    city
    country
    createdAt
    email
    firstName
    id
    lastName
    phone
    roles {
      claims {
        createdAt
        pattern
        updatedAt
      }
      createdAt
      id
      name
      updatedAt
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listVehicles = /* GraphQL */ `query ListVehicles {
  listVehicles {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesQueryVariables,
  APITypes.ListVehiclesQuery
>;
export const listVehiclesByFleetId = /* GraphQL */ `query ListVehiclesByFleetId($fleetId: ID!) {
  listVehiclesByFleetId(fleetId: $fleetId) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesByFleetIdQueryVariables,
  APITypes.ListVehiclesByFleetIdQuery
>;
export const listVehiclesByFleetIdV2 = /* GraphQL */ `query ListVehiclesByFleetIdV2($fleetId: ID!) {
  listVehiclesByFleetIdV2(fleetId: $fleetId) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on VehicleList {
      items {
        activeMissionId {
          error {
            raisedAt
            type
          }
          ttl
          value {
            data
            updatedAt
          }
        }
        adsState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        connectivityStatus {
          error {
            raisedAt
            type
          }
          ttl
          value {
            expectDisconnection
            latency
            state
            updatedAt
          }
        }
        deviations {
          error {
            raisedAt
            type
          }
          ttl
          value {
            deviation {
              category
              description
              id
              isBlocking
              origin
              relatedDeviations
              resolvedAt
              sentAt
              severity
              state
            }
            updatedAt
          }
        }
        driverMode {
          error {
            raisedAt
            type
          }
          ttl
          value {
            mode
            updatedAt
          }
        }
        drivingState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        fleetId
        latestVehicleUpdate
        licensePlate
        mrmState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            data {
              causes
              executionPhase
              mrmType
              startedAt
              triggerBy
              value
            }
            updatedAt
          }
        }
        name
        owners {
          email
          fullName
          id
          phoneNumber
          position
        }
        position {
          error {
            raisedAt
            type
          }
          ttl
          value {
            position {
              altitude
              heading
              latitude
              longitude
            }
            updatedAt
          }
        }
        speedMs {
          error {
            raisedAt
            type
          }
          ttl
          value {
            speedMs
            updatedAt
          }
        }
        timestamp
        vin
      }
    }
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesByFleetIdV2QueryVariables,
  APITypes.ListVehiclesByFleetIdV2Query
>;
export const listVehiclesV2 = /* GraphQL */ `query ListVehiclesV2 {
  listVehiclesV2 {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on VehicleList {
      items {
        activeMissionId {
          error {
            raisedAt
            type
          }
          ttl
          value {
            data
            updatedAt
          }
        }
        adsState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        connectivityStatus {
          error {
            raisedAt
            type
          }
          ttl
          value {
            expectDisconnection
            latency
            state
            updatedAt
          }
        }
        deviations {
          error {
            raisedAt
            type
          }
          ttl
          value {
            deviation {
              category
              description
              id
              isBlocking
              origin
              relatedDeviations
              resolvedAt
              sentAt
              severity
              state
            }
            updatedAt
          }
        }
        driverMode {
          error {
            raisedAt
            type
          }
          ttl
          value {
            mode
            updatedAt
          }
        }
        drivingState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        fleetId
        latestVehicleUpdate
        licensePlate
        mrmState {
          error {
            raisedAt
            type
          }
          ttl
          value {
            data {
              causes
              executionPhase
              mrmType
              startedAt
              triggerBy
              value
            }
            updatedAt
          }
        }
        name
        owners {
          email
          fullName
          id
          phoneNumber
          position
        }
        position {
          error {
            raisedAt
            type
          }
          ttl
          value {
            position {
              altitude
              heading
              latitude
              longitude
            }
            updatedAt
          }
        }
        speedMs {
          error {
            raisedAt
            type
          }
          ttl
          value {
            speedMs
            updatedAt
          }
        }
        timestamp
        vin
      }
    }
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesV2QueryVariables,
  APITypes.ListVehiclesV2Query
>;
